import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import LocationServices from "../../../services/LocationServices";
import Swal from "sweetalert2";
import LocationEditModal from './LocationEditModal';
import Select from 'react-select';
import Loader from "../Loader/loader";
import Pagination from "../Pagenation/Pagenation";


const InactiveLocation = ({
  activeTab,
  setActiveTab,
  setShowAddModal, }) => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sort, setSort] = useState('');
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [run, setRun] = useState(0)


  const options = [
    //{ value: '1', label: 'Select Status' },
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ]

  // Fetch data from API
  useEffect(() => {
    setLoading(true);
    LocationServices.getStore()
      .then((res) => {
        const filteredInactiveStores = res.data.data.filter(
          (store) => store.status === "inactive"
        );

        setData(filteredInactiveStores);
        setFilteredData(filteredInactiveStores);
      })
      .catch((error) => {
        console.error(error);
        setError("There was a problem fetching the data!");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [run]);

  useEffect(() => {
    const lowerSearch = searchQuery.toLowerCase();

    const filtered = data.filter((item) =>
      item?.name?.toLowerCase().includes(lowerSearch) ||
      item?.location?.toLowerCase().includes(lowerSearch) ||
      item?.storeCode?.toLowerCase().includes(lowerSearch) ||
      item?.status?.toLowerCase().includes(lowerSearch)
    );

    setFilteredData(filtered);
    activePag.current = 0;
  }, [searchQuery, data]);

  useEffect(() => {
    activePag.current = 0;
  }, [sort]);

  const rowsPerPage = Number(sort) || 10;
  const pagination = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));
  const visibleData = filteredData.slice(
    activePag.current * rowsPerPage,
    (activePag.current + 1) * rowsPerPage
  );



  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  // Handle status toggle for Active users
  const handleStatusToggle = async (item) => {
    const newStatus = item.status === "inactive" ? "active" : "inactive";
    const updatedUser = { ...item, status: newStatus }; // Create updated user object

    try {
      await LocationServices.updateStore(item._id, updatedUser); // Use the updateUser service
      setRun(prev => prev + 1); // Trigger re-fetch or re-render
      Swal.fire('Success!', `User status updated to ${newStatus}.`, 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error!', 'There was a problem updating the user status.', 'error');
    }
  };

  if (loading) {
    return (
      <Loader />
    );
  }
  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link to={"#"} className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-xxl-6">
                      <input
                        type="text"
                        className="form-control mb-xl-0 mb-3"
                        placeholder="Search by store name, location, or status"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    <div className="col-xl-3 col-xxl-6">
                      <Select
                        placeholder="Select row to display in User Table"
                        value={sort ? options.find((option) => Number(option.value) === Number(sort)) : null}
                        onChange={(selectedOption) => setSort(selectedOption ? String(selectedOption.value) : '')}
                        isSearchable={false}
                        options={options}
                        className="custom-react-select mb-3 mb-xxl-0"
                      />
                    </div>

                  </div>

                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">

              {/* Mobile Row 1 */}
              <div className="d-flex justify-content-between align-items-center w-100 d-md-none">
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>
                  Inactive Stores
                  <span className="badge bg-orange ms-2">
                    {filteredData.length}
                  </span>
                </div>

                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>

              {/* Desktop Left */}
              <div className="cpa text-center text-md-start d-none d-md-block">
                <i className="fa fa-list me-2" aria-hidden="true"></i>
                Inactive Stores
                <span className="badge bg-orange ms-2">
                  {filteredData.length}
                </span>
              </div>

              {/* Center Tabs */}
              <div
                className="d-flex align-items-center flex-nowrap order-2 order-md-0 align-self-start"
                style={{
                  background: "#f1f3f5",
                  padding: "5px",
                  borderRadius: "12px",
                  border: "1px solid #dee2e6",
                }}
              >
                <button
                  type="button"
                  onClick={() => setActiveTab("active")}
                  style={{
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "8px",
                    background: activeTab === "active" ? "#0d6efd" : "transparent",
                    color: activeTab === "active" ? "#fff" : "#495057",
                    fontSize: "13px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "0.2s ease",
                    whiteSpace: "nowrap",
                  }}
                >
                  Active Locations
                </button>

                <button
                  type="button"
                  onClick={() => setActiveTab("inactive")}
                  className="ms-2"
                  style={{
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "8px",
                    background: activeTab === "inactive" ? "#0d6efd" : "transparent",
                    color: activeTab === "inactive" ? "#fff" : "#495057",
                    fontSize: "13px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "0.2s ease",
                    whiteSpace: "nowrap",
                  }}
                >
                  Inactive Locations
                </button>
              </div>

              {/* Desktop Right */}
              <div className="tools d-none d-md-flex align-items-center justify-content-center">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>

            <div className="row me-0 me-md-3">
              <div className="col-12 d-flex w-100 justify-content-start justify-content-md-end ms-3 ms-md-0 me-md-4 mb-2">
                <button
                  type="button"
                  className="btn btn-primary btn-sm d-flex align-items-center"
                  onClick={() => setShowAddModal(true)}
                >
                  <i className="fas fa-plus me-2"></i>
                  Add Location
                </button>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <div className="scrolltable">
                        <table
                          className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                          id="inactive-locations-data"
                        >
                          <thead clssName="sticky-table-header">
                            <tr>
                              <th>S.No</th>
                              <th>Store Name</th>
                              <th>Location</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(visibleData) && visibleData.length > 0 ? (
                              visibleData.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    {activePag.current * rowsPerPage + index + 1}
                                  </td>
                                  <td>{item?.name}</td>
                                  <td>{item?.location}</td>
                                  <td>
                                    <span
                                      onClick={() => handleStatusToggle(item)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <i
                                        className={`fa ${item.status === 'inactive' ? 'fa-circle text-danger' : 'fa-circle text-success'}`}
                                        title={item.status === 'inactive' ? 'Inactive' : 'Active'}
                                      ></i>
                                    </span>
                                  </td>

                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5">No inactive stores</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          Showing {filteredData.length > 0 ? activePag.current * rowsPerPage + 1 : 0} to{" "}
                          {Math.min(
                            filteredData.length,
                            (activePag.current + 1) * rowsPerPage
                          )}{" "}
                          of {filteredData.length} entries
                        </div>

                        <Pagination activePage={activePag.current}
                          totalPages={pagination}
                          onPageChange={onClick} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>


    </>
  );
};

export default InactiveLocation;
